<template>
    <div class="selector_bottom">
    </div>
</template>

<script>
export default {
  name: 'Bottom',
  props: ['x', 'y'],
  data: () => ({}),
  computed: {}
}
</script>

<style scoped>
    .selector_bottom {
        background: url(~@/assets/lines/bottom.png);
        width: 250px;
        height: 175px;
    }
</style>



// WEBPACK FOOTER //
// src/components/selector/Bottom.vue